module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/49.918c7fd6.png";